import {devAlert} from '@packages/systems/spring-hooks';

type Value =
  | 0
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12
  | 13
  | 14
  | 15
  | 16
  | 0.5
  | 0.25
  | -0.25
  | -0.5
  | -1
  | -2
  | -3
  | -4
  | -5
  | -6
  | -7
  | -8
  | -9
  | -10
  | -11
  | -12
  | -13
  | -14
  | -15
  | -16
  | {
      _override?: string;
    };

export const space = {
  '0': '0px',
  '0.25': '1px',
  '0.5': '2px',
  '1': '4px',
  '2': '8px',
  '3': '12px',
  '4': '16px',
  '5': '20px',
  '6': '24px',
  '7': '28px',
  '8': '32px',
  '9': '36px',
  '10': '40px',
  '11': '44px',
  '12': '48px',
  '13': '52px',
  '14': '56px',
  '15': '60px',
  '16': '64px',
  '-0.25': '-1px',
  '-0.5': '-2px',
  '-1': '-4px',
  '-2': '-8px',
  '-3': '-12px',
  '-4': '-16px',
  '-5': '-20px',
  '-6': '-24px',
  '-7': '-28px',
  '-8': '-32px',
  '-9': '-36px',
  '-10': '-40px',
  '-11': '-44px',
  '-12': '-48px',
  '-13': '-52px',
  '-14': '-56px',
  '-15': '-60px',
  '-16': '-64px',
  override: (value: string): string | undefined => {
    devAlert(
      true,
      'Be mindful of using space overrides. Please contact Design to verify that this is an intended value.'
    );

    if (typeof value === 'string') return value;
    return undefined;
  },
  getValue: function (value?: Value): string {
    if (typeof value !== 'number') return value?._override ?? '';
    if (value < -16) value = -16;
    if (value > 16) value = 16;
    return this[value];
  },
} as const;
